import React from 'react';
import {adminColorEvidence} from '../../../../../utils/adminStockEvidence';

export default function AdminSizeStock({state, productId, childProductId, sizeName}) {
  const color = adminColorEvidence(state, productId, childProductId);
  const stock = color?.sizes.find(size => size.sizeName === sizeName)?.stock;
  if (!stock) return <span className="admin_size_stock" role="status">Остаток не подтверждён. Ручное наличие заблокировано.</span>;
  if (stock.state === 'not_applicable') return <span className="admin_size_stock">Сертификат: отдельное ручное наличие.</span>;
  return <span className="admin_size_stock" data-state={stock.state}>
    {stock.state === 'confirmed' ? `Остаток 1С: ${stock.quantity}`
      : stock.state === 'stale' ? `Устаревший остаток 1С: ${stock.quantity}` : 'Не подтверждено — не нулевой остаток'}
    {stock.sourceAsOf && <> · Источник 1С: <time dateTime={stock.sourceAsOf}>{stock.sourceAsOf}</time></>}
    {stock.confirmedAt && <> · Подтверждение: <time dateTime={stock.confirmedAt}>{stock.confirmedAt}</time></>}
    {' · '}{stock.reasonCode}
  </span>;
}
